import React, { useMemo, useState } from "react";
import { SettingItem, SettingLine } from "./styled";
import { FormattedMessage } from "react-intl";
import { Tooltip } from "@bit-design/react";
import { TimezoneEnum } from "constants/vars";
import PlainDropdown from "components/common/PlainSelect";
import { useUserPreferenceSetting } from "store/data/User";
import {
  getTimezoneDisplayByOffset,
  SupportedChangeTimezone,
  Last24HOption,
} from "constants/base";
import Drawer from "rc-drawer";
import cs from "classnames";
import { useRecoilState } from "recoil";
import { ChangeTimezoneSelector } from "store/v2/Base";
import { useMyIntl } from "../../../hooks";
import IconJiantou from "assets/icon/icon-jiantou.svg";
import IconMore from "assets/icon/icon-more.svg";
import style from "./timezone.module.less";

const TimezoneSitting = () => {
  const [userPreferenceSetting, setUserPreferenceSetting] =
    useUserPreferenceSetting();
  const t = useMyIntl();
  const TimezoneMap = useMemo<{
    [key: string]: string | React.ReactElement;
  }>(() => {
    return {
      [TimezoneEnum.UTC]: "UTC +0, 0:00",
      [TimezoneEnum.SHANGHAI]: "UTC +8, 0:00",
    };
  }, []);
  const [zone, setZone] = useState(false);
  const [open, setOpen] = useState(false);
  const [changeTimezone, setChangeTimezone] = useRecoilState(
    ChangeTimezoneSelector
  );

  return (
    <div className="w-full">
      {/* K线时区 */}
      <div
        className={
          "font-space-grotesk text-[var(--separation-cointr-color-fill4)] text-[16px] py-[20px]"
        }
      >
        <FormattedMessage id={"user_preference.change_kline_title"} />
        <Tooltip
          zIndex={20000}
          title={
            userPreferenceSetting.timezone === TimezoneEnum.UTC ? (
              <FormattedMessage id={"user_preference.change_kline_tip_utc0"} />
            ) : (
              <FormattedMessage id={"user_preference.change_kline_tip_utc8"} />
            )
          }
          placement={"top"}
        >
          <i
            className={
              "iconfont icon-tishi1 text-[12px] ml-[4px] text-disabledText"
            }
          />
        </Tooltip>
      </div>
      <SettingItem>
        <span className={"setting-item-part"}>
          {TimezoneMap[userPreferenceSetting.timezone]}
        </span>

        <div className={"setting-item-part"}>
          <PlainDropdown
            items={TimezoneMap}
            onSelect={(zone: TimezoneEnum) => {
              setUserPreferenceSetting({ timezone: +zone });
              setZone(false);
            }}
            onVisibleChange={(visible) => {
              setZone(visible);
            }}
            value={"" + userPreferenceSetting.timezone}
            placement={"bottomRight"}
            dropdownRootClassName={style.timezoneDropdown}
          >
            <div
              className={
                "cursor-pointer flex items-center justify-start w-112px flex-row-reverse"
              }
            >
              <i>
                {/* <img src={IconJiantou} alt={"icon-jiantou"} /> */}
                <i onClick={() => setZone(true)}>
                  {zone ? (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                    >
                      <path
                        d="M12 10L8 6L4 10"
                        stroke="var(--cointr-color-success1)"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  ) : (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                    >
                      <path
                        d="M4 6L8 10L12 6"
                        stroke="var(--cointr-color-text1)"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  )}
                  {/* <img src={!zone ? linejt : linejtAct} alt={'icon-jiantou'} /> */}
                </i>
              </i>
            </div>
          </PlainDropdown>
        </div>
      </SettingItem>
      <SettingLine></SettingLine>
      {/* 涨跌幅时区 */}
      <div
        className={
          "font-space-grotesk text-[var(--separation-cointr-color-fill4)] text-[16px] py-[20px]"
        }
      >
        <FormattedMessage
          id={"user_preference.change_basis_title"}
          defaultMessage={"Change Basis"}
        />
        <Tooltip
          zIndex={20000}
          title={
            <div>
              <p className="leading-22px mb-5px">
                <FormattedMessage id={"user_preference.change_basis_tip2"} />
              </p>
            </div>
          }
          placement={"top"}
        >
          <i
            className={
              "iconfont icon-tishi1 text-[12px] ml-[4px] text-disabledText"
            }
          />
        </Tooltip>
      </div>
      <SettingItem>
        <span className="text-[var(--cointr-color-text2)]">
          {changeTimezone === Last24HOption ? (
            <FormattedMessage
              id={"user_preference.change_basis_last_24_hours"}
              defaultMessage={"Last 24 hours"}
            />
          ) : (
            getTimezoneDisplayByOffset(Number(changeTimezone))
          )}
        </span>
        <div className={"setting-item-part"}>
          <div
            className={"cursor-pointer flex items-center justify-start"}
            onClick={() => setOpen(true)}
          >
            {/* <img src={IconMore} alt={"icon-more"} /> */}
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
            >
              <path
                d="M6 12L10 8L6 4"
                stroke="var(--cointr-color-text1)"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>
        </div>
      </SettingItem>
      <SettingLine></SettingLine>
      <Drawer
        placement={"right"}
        onClose={() => setOpen(false)}
        open={open}
        width={375}
        maskStyle={{ backgroundColor: "transparent" }}
      >
        <div className={"py-[20px]"}>
          <div className={"flex justify-start items-center px-[24px]"}>
            <div
              onClick={() => setOpen(false)}
              className={"cursor-pointer text-primaryText"}
            >
              <i
                className={
                  "iconfont icon-ic_insight_previous text-[20px] ml-[-6px]"
                }
              />
            </div>
          </div>
          <div className={"py-[30px] px-[24px]"}>
            <div
              className={
                "text-[16px] text-primaryText leading-[22px] mb-[18px]"
              }
            >
              <FormattedMessage
                id={"user_preference.change_basis_title"}
                defaultMessage={"Change Basis"}
              />
            </div>
            <div className={"text-[12px] leading-[18px] text-thirdText"}>
              <FormattedMessage
                id={"user_preference.change_basis_tip2"}
                defaultMessage={
                  "Switching to a new time zone will only effect the change (%) for market information. This change will not apply to Kline candlesticks."
                }
              />
            </div>
          </div>
          <div>
            <ul className={"flex flex-col"}>
              <li
                className={
                  "flex justify-between items-center text-[16px] leading-[22px] py-[20px] px-[24px] cursor-pointer text-primaryText -order-2 hover:bg-secondaryBtnBg"
                }
                onClick={() => setChangeTimezone(Last24HOption)}
              >
                <span>
                  <FormattedMessage
                    id={"user_preference.change_basis_last_24_hours"}
                    defaultMessage={"Last 24 hours"}
                  />
                </span>
                {Last24HOption === changeTimezone ? (
                  <i
                    className={
                      "iconfont icon-ic_insight_done_small text-primary"
                    }
                  />
                ) : null}
              </li>
              {SupportedChangeTimezone.map((i) => {
                const isLocalTimezone =
                  new Date().getTimezoneOffset() === Number(i);
                return (
                  <li
                    className={cs(
                      "flex justify-between items-center text-[16px] leading-[22px] py-[20px] px-[24px] cursor-pointer text-primaryText hover:bg-[var(--cointr-color-fill2)]",
                      { "-order-1": isLocalTimezone }
                    )}
                    key={i}
                    onClick={() => setChangeTimezone(String(i))}
                  >
                    <span>
                      {getTimezoneDisplayByOffset(i)}
                      {isLocalTimezone
                        ? t(
                            "user_preference.change_basis_local",
                            "Local Time Zone"
                          )
                        : ""}
                    </span>
                    {String(i) === changeTimezone ? (
                      <i
                        className={
                          "iconfont icon-ic_insight_done_small text-primary"
                        }
                      />
                    ) : null}
                  </li>
                );
              })}
            </ul>
          </div>
        </div>
      </Drawer>
    </div>
  );
};

export default TimezoneSitting;
